<!--
  页脚
  用途：展示版权信息、快捷导航与联系方式
  用法：放在 AppLayout 底部；Logo 仅使用红色图标
-->
<template>
  <div id="site-footer" class="site-footer" role="contentinfo" data-footer="duogu">
    <div class="footer-inner">
      <div class="footer-brand">
        <img class="footer-logo" :src="logoUrl" :alt="t('common.brandLogoAlt')" />
        <p>{{ t('footer.desc') }}</p>
      </div>

      <div class="footer-links">
        <h4>{{ t('footer.quickLinks') }}</h4>
        <router-link to="/">{{ t('common.home') }}</router-link>
        <router-link to="/cases">{{ t('common.cases') }}</router-link>
        <router-link to="/contact">{{ t('common.contact') }}</router-link>
      </div>

      <div class="footer-contact">
        <h4>{{ t('footer.contactTitle') }}</h4>
        <p>
          <a class="footer-link" href="mailto:2017emilyli@gmail.com">{{ t('footer.emailLine') }}</a>
        </p>
        <p>
          <a
            class="footer-link"
            href="https://wa.me/8618666080334"
            target="_blank"
            rel="noopener noreferrer"
          >{{ t('footer.whatsappLine') }}</a>
        </p>
        <p>{{ t('footer.addressLine') }}</p>
      </div>
    </div>

    <div class="footer-bottom">
      <span>© {{ year }} Duogu Sourcing Agency Co., Ltd. {{ t('footer.rights') }}</span>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import logoUrl from '@/assets/logo.png'

const { t } = useI18n()
const year = new Date().getFullYear()
</script>

<style scoped>
/* 使用显式颜色，避免 CSS 变量未加载时白字白底导致“页脚消失” */
.site-footer {
  position: relative;
  z-index: 20;
  flex-shrink: 0;
  width: 100%;
  background: #1a1a1a;
  color: rgba(255, 255, 255, 0.86);
  margin-top: auto;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  min-height: 200px;
}

.footer-inner {
  box-sizing: border-box;
  max-width: var(--max-width, 1200px);
  margin: 0 auto;
  padding: 48px 24px 28px;
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 32px;
}

.footer-logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin-bottom: 14px;
}

.footer-brand p,
.footer-contact p {
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  line-height: 1.7;
  margin: 0;
}

.footer-links,
.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.footer-links h4,
.footer-contact h4 {
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 4px;
}

.footer-links a,
.footer-link {
  color: rgba(255, 255, 255, 0.75) !important;
  font-size: 14px;
  line-height: 1.6;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-links a:hover,
.footer-link:hover {
  color: #ffffff !important;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  text-align: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
}

@media (max-width: 768px) {
  .footer-inner {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 36px 16px 24px;
  }
}
</style>
